import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DataService, DatasetBannerModel} from 'src/app/services/data.service';
import {SessionService, UserType} from 'src/app/services/session.service';
import {FileService} from 'src/app/services/file.service';

@Component({
  selector: 'app-ia-iframe',
  templateUrl: './ia-iframe.component.html',
  styleUrls: ['./ia-iframe.component.scss'],
})
export class IframIAComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
